module.exports = __webpack_public_path__ + "static/media/tag.9d4de5a1.svg";